<template>
  <div class="helpPerformanceBox">
    <div class="helpcloginCon">
      <div class="bigTitle" @click="backFn('showa')">
        <span></span>开放平台
      </div>
      <div class="smallTile" v-show="showa">
        <p
          style="text-indent:2em"
        >在智签的坐标体系中，页面签章中以页面的左下角为坐标原点，以签名/印章图片的左下角与右上角来计算图片所在的位置坐标，位置坐标为一个带小数点的像素单位值。骑缝章以页面的右下角为坐标原点，以签名/印章图片的底边来计算图片所在位置，具体为位置坐标的Y值，为一个带小数点的像素单位值。</p>
        <div class="toItemBox">
          <dl>
            <dt class="itemLinkIcon" @click="toPositionTool">
              <img class="iconNormal" src="@image/helpCenter/qzwzgj_icon_nor.png">
              <img class="iconHov" src="@image/helpCenter/qzwzgj_icon_hov_pre.png">
            </dt>
            <dd class="itemLinkDscp">
              点击
              <img src="@image/helpCenter/click_icon.png">使用智签签章位置工具
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showa: true
    };
  },
  methods: {
    toPositionTool() {
      window.open("/verification/toolPosition", "_blank");
    },
    backFn(flag) {
      if (this[flag] == true) {
        this[flag] = false;
      } else {
        this[flag] = true;
      }
    }
  }
};
</script>
<style lang="scss">
.toItemBox {
  width: 100%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  .itemLinkIcon {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .iconHov {
      display: none;
    }
    .iconNormal {
      display: block;
    }
    &:hover {
      .iconHov {
        display: block;
      }
      .iconNormal {
        display: none;
      }
    }
  }
  .itemLinkDscp {
    font-size: 14px;
    color: #ed4559;
    line-height: 46px;
    img {
      vertical-align: middle;
      margin-left: 5px !important;
      margin-right: 5px;
    }
  }
}
</style>
